import { ChangeDetectionStrategy, Component, NgZone } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { DateTime } from 'luxon';
import { CookiesService } from '@shared/services/cookie.service';

@Component({
  selector: 'app-cookie-agreement',
  templateUrl: './cookie-agreement.component.html',
  styleUrls: ['./cookie-agreement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieAgreementComponent {

  constructor(
    private ngZone: NgZone,
    public snackBarRef: MatSnackBarRef<CookieAgreementComponent>,
    private cookieService: CookiesService,
  ) {}

  public close(): void {
    this.setAgreement();
    this.ngZone.run(() => {
      this.snackBarRef.dismiss();
    });
  }

  private setAgreement() {
    const year = DateTime
      .fromJSDate(new Date())
      .plus({ year: 1 })
      .toSeconds();
    this.cookieService.setCookie('cookie-agreement', 'true', year);
  }
}
